<template>
    <div class="page background-style">
        <div class="background-image-style">
            <!-- QrmTool landing photo -->
        </div>
        <div class="landing-title">
            {{$t('components.navigation_bar.title_esign')}}
        </div>
        <div class="landing-options">
            <router-link to="/ESign" tag="a" class="option" v-if="$store.getters.isInRoleArr('ADMIN,R_ESIGN_ADMIN,View_ESignArea/ESign/Index')">
                <div class="img-icon-wrapper">
                    <img :src="'/static/image/ESignJLL.svg'" class="img-icon">
                </div>
                <div class="option-text">
                    {{$t('components.navigation_bar.title_esign_JLL')}}
                </div>
            </router-link>
            <v-divider vertical color="white" class="menu-divider"></v-divider>
            <router-link to="/ESignTetris" tag="a" class="option" v-if="$store.getters.isInRoleArr('ADMIN,R_TETRIS_ESIGN_ADMIN,View_TetrisESignArea/TetrisESign/Index')">
                <div class="img-icon-wrapper">
                    <img :src="'/static/image/ESignTetris.svg'" class="img-icon">
                </div>
                <div class="option-text">
                    {{$t('components.navigation_bar.title_esign_TETRIS')}}
                </div>
            </router-link>
            <v-divider vertical color="white" class="menu-divider"></v-divider>
            <router-link to="/ESignDashboard" tag="a" class="option" v-if="$store.getters.isInRoleArr('DASHBOARD_OVERVIEW,DASHBOARD_JLL,DASHBOARD_TETRIS')">
                <div class="img-icon-wrapper">
                    <img :src="'/static/image/Dashboard.svg'" class="img-icon">
                </div>
                <div class="option-text">
                    {{$t('components.navigation_bar.title_esign_dashboard')}}
                </div>
            </router-link>
            <v-divider vertical color="white" class="menu-divider"></v-divider>
            <router-link to="/ESignJLLT" tag="a" class="option" v-if="$store.getters.isInRoleArr('JLLT_VIEW')">
                <div class="img-icon-wrapper">
                    <img :src="'/static/image/JLLT.svg'" class="img-icon">
                </div>
                <div class="option-text">
                    {{$t('components.navigation_bar.title_esign_JLLT')}}
                </div>
            </router-link>
            <v-divider vertical color="white" class="menu-divider"></v-divider>
            <router-link to="/ESignHR" tag="a" class="option" v-if="$store.getters.isInRoleArr('ADMIN, HR_ADMIN')">
                <div class="img-icon-wrapper">
                    <img :src="'/static/image/ESignHR.svg'" class="img-icon">
                </div>
                <div class="option-text">
                    {{$t('components.navigation_bar.title_esign_HR')}}
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: "LandingESign",
        data() {
            return {
            };
        },
        methods: {
            fnNavTo(pageto) {
                window.open(pageto, "_blank");
            },
            fnNavToInternal(to) {
                this.$router.push(to);
            },
        },
    };
</script>

<style scoped>
    .background-style {
        background-color: var(--jll-gray);
        background-repeat: no-repeat;
        background-image: url(../../assets/IRIS_background_landing_v2.png);
        background-position: bottom left; /* Cambiado a bottom left */
        background-size: cover;
        position: fixed;
        width: 100%;
        height: 100vh;
        top: 0;
        padding-top: 30vh;
        overflow-y: auto;
    }

    .img-icon {
        height: 2vw;
        width: 2vw;
    }

    .img-icon-wrapper {
        display: flex;
        align-items: center;
    }

    .background-style:after {
        position: absolute;
        content: '';
        display: block;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background: rgb(192,220,228);
        mix-blend-mode: color;
        z-index: -1;
    }

    .menu-divider {
        min-height: 3vw !important;
        max-height: 3vw !important;
        min-width: 0.05vw !important;
        max-width: 0.05vw !important;
    }

    .landing-title {
        font-size: 6vw !important;
        overflow: hidden;
        color: white;
        font-family: "iris-bold";
        color: rgb(23, 23, 23);
    }

    .page {
        display: flex;
        flex-direction: column;
    }

    .landing-options {
        padding: 0.6vw;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-self: center;
        background-color: black;
        border-radius: 10px;
        opacity: 0.9;
    }

        .landing-options .option {
            cursor: pointer;
            display: flex;
            margin-left: 1.6vw;
            margin-right: 1.6vw;
        }

            .landing-options .option:hover .option-icon {
                background-color: darkgray;
                transition: 0.2s;
                text-shadow: 0 0 0.12vw #fff, 0 0 7vw #fff, 0 0 1vw #fff, 0 0 12.1vw #f00, 0 0 0vw #f00, 0 0 41vw #f00, 0 0 1vw #f00, 0 0 26vw #f00;
            }

            .landing-options .option .option-icon {
                min-height: 24px;
                background-color: lightgray;
                border-radius: 100%;
                transition: 0.2s;
                margin-top: 1vh;
                color: white
            }

            .landing-options .option:hover .option-text {
                opacity: 1;
                padding-top: 0px;
                text-shadow: 0 0 0.12vw #fff, 0 0 7vw #fff, 0 0 1vw #fff, 0 0 12.1vw #f00, 0 0 0vw #f00, 0 0 41vw #f00, 0 0 1vw #f00, 0 0 26vw #f00;

            }

            .landing-options .option .option-text {
                font-size: 2.2vw;
                transition: 0.08s;
                position: relative;
                /* padding-top: 2px; */
                color: white;
                font-family: "iris-medium";
                padding-left: 0.25vw;
                padding-right: 0.25vw;
                display: flex;
                align-items: center
            }


    a:hover {
        transition: 0.2s;
        text-decoration: none;
    }

    a{

    }


</style>
